import { NgModule } from '@angular/core';
import { BackendModule, SearchModule } from '@freelancer/datastore/core';
import { searchContestsBackend } from './search-contests.backend';
import { transformSearchContests } from './search-contests.transformers';

@NgModule({
  imports: [
    SearchModule.forFeature('searchContests', transformSearchContests),
    BackendModule.forFeature('searchContests', searchContestsBackend),
  ],
})
export class DatastoreSearchContestsModule {}



// WEBPACK FOOTER //
// ./src/@freelancer/datastore/search-contests/search-contests.module.ts